import { CompletionStatusChange } from '../../../compoundManagement/compoundManagement.types';
import { ApiCompletionStatusChange } from '../../types/compoundManagement/compoundManagementApi.types';
import { mapToApiTransportInformation } from './compoundManagementMappers';

export const mapToApiStatusCompletion = ({
    statusAt,
    transportInformation,
    compoundVehicleIds,
}: CompletionStatusChange): ApiCompletionStatusChange => ({
    status_at: statusAt.toISOString(),
    compound_vehicle_ids: compoundVehicleIds,
    transport_information: mapToApiTransportInformation(transportInformation),
});
